/* eslint-disable */
// Don't check the return type here. This allows `ReturnType<T>` to work

/**
 * Create styles for `<Trucks />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Trucks />` styles
 */
const trucksStyles = ({ theme }) => ({
  trucksSpinner: {
    position: `absolute`,
    right: -93,
    top: 14,
  },
  viewMap: {
    position: `absolute`,
    right: 16,
    top: 14,
  },
  renderTrucksContainer: {
    padding: theme.spacing(1) * 2,
    minHeight: `100vh`,
  },
});

export default trucksStyles;
